import { createFileRoute } from "@tanstack/react-router"
import DesignSystemColorTokens from "~/pages/design-system/styles/ColorTokens"

export const Route = createFileRoute("/_auth/internal/design-system/styles/color-tokens")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemColorTokens />
}
